import { render } from "./LineChartMonth.vue?vue&type=template&id=3d5e51a7"
import script from "./LineChartMonth.vue?vue&type=script&lang=js"
export * from "./LineChartMonth.vue?vue&type=script&lang=js"
script.render = render

export default script